<template>
  <div
    @click.stop="selectComponent(model)"
    :class="[ {'dr-simple-layout-selected' : isSelected}, 'dr-navigation' ]"
    v-if="isInEditorMode"
  >

    <portal to="action-buttons" v-if="isSelected">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" :disabled='readonly' text color="error" @click="onDeleteComponent">
            <font-awesome-icon :icon="['fal', 'trash-alt']" size="lg"/>
          </v-btn>
        </template>
        <span>{{ $t("vuetifyWidgets.common.remove") }}</span>
      </v-tooltip>
    </portal>

    <v-navigation-drawer
      :color="model.Color"
      :dark="model.DarkMode"
    >

      <draggable
        class="draggable-target-navigation-drawer"
        :group="{ name:'container', put:['toolbox', 'container'] }"
        @add="onWidgetDraggableAdd"
        :swapThreshold="0.95"
        :emptyInsertThreshold="20"
        @update="onModelChanged"
        :disabled="readonly"
        :list="model.Widgets"
      >
        <component v-for="widget in model.Widgets"
          :parentsWidgets="currentListOfParentsWidgets"
          :readonly='readonly'
          :key="widget.$ID"
          :is="widget.$Type"
          :model="widget"
          @modelChanged="onModelChanged"
          @deleteComponent="onDeleteWidget"
        />
      </draggable>

    </v-navigation-drawer>
  </div>

  <v-navigation-drawer v-else
    :color="model.Color"
    :dark="model.DarkMode"
    :expand-on-hover="model.ExpandOnHover"
    :mini-variant="model.MiniVariant"
    :app="true"
  >
    <template  v-for="widget in model.Widgets">
      <component
        :dataSource="dataSource"
        :parentDataWidget="parentDataWidget"
        @callDataSourceAction="$emit('callDataSourceAction', $event)"
        :key="widget.$ID"
        :is="widget.$Type"
        :model="widget"
      />
    </template>
  </v-navigation-drawer>

</template>

<script>
import mixin from '../../mixins/base-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'

export default {
  data () {
    return {
      drawer: true,
      color: 'primary'
    }
  },
  mixins: [mixin, widgetsWrapperMixin],
  methods: {
    onModelChanged() {
      this.$emit('modelChanged', this.model)
    },
    onDeleteWidget(val) {
      this.model.Widgets = this.model.Widgets.filter(comp => comp != val)
      this.$emit('modelChanged', this.model)
      this.widgetsHelper.setSelectedWidget(undefined)
    }
  }
}
</script>

<style>
.draggable-target-navigation-drawer{
  display: flex;
  align-items: center;
  min-width: 100px;
  height: 100%;
  width: -webkit-fill-available;
  margin: 5px;
  outline: 2px dashed #FFA500;
  display: inline-block;
}
.draggable-target-navigation-drawer:empty::after{
  content: "Drop widgets here";
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  padding: 0 10px;
  color: #FFA500;
}



.dr-navigation /deep/ .v-navigation-drawer {
  will-change: auto !important;
  transform: none !important;
}

</style>
